export default [
  {
    name: 'to_be_determined',
    publicName: 'À déterminer'
  },
  {
    name: 'valid',
    publicName: 'Valide'
  },
  {
    name: 'defective',
    publicName: 'Défectueux'
  },
  {
    name: 'missing',
    publicName: 'Manquant'
  }
];
